import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { markCookieBannerSeen } from '../../../redux/actions/app/appActions';
import openPrivacyPolicy from '../../../utils/openPrivacyPolicy';
import Clickable from '../../Buttons/Clickable';
import { CookieConfirmButton } from './components/CookieConfirmButton';
import styles from './CookieBanner.module.css';
import { getLandingClusterByClusterId } from '../../../utils/landingClusterUtils';
import getPathParams from '../../../utils/getPathParams';

const CookieBanner = () => {
  const { cookieBannerSeen } = useSelector((state) => state.persist.app);
  const { landing } = useSelector((state) => state.persist);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const location = useLocation();

  if (cookieBannerSeen) {
    return null;
  }

  const getClusterId = (pathname) => {
    return getPathParams(pathname)?.clusterId;
  };

  const onClick = () => {
    dispatch(markCookieBannerSeen());
  };

  const findClusterByRedux = getLandingClusterByClusterId(landing.clusterId);
  const clusterId = getClusterId(location.pathname);
  const findClusterByPathName = getLandingClusterByClusterId(clusterId);

  let cookieText;
  if (findClusterByRedux) {
    cookieText = findClusterByRedux.cookieBanner;
  } else if (findClusterByPathName) {
    cookieText = findClusterByPathName.cookieBanner;
  } else {
    cookieText = t('cookieBanner.text');
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <div className={styles.textContainer}>
          <p className={styles.text}>
            {cookieText}
            <Clickable onClick={openPrivacyPolicy}>
              <p className={styles.linkText}>{t('cookieBanner.linkText')}</p>
            </Clickable>
            .
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <CookieConfirmButton
            onClick={onClick}
            buttonText={t('cookieBanner.button')}
          />
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
